import React, { Fragment } from 'react';
import './Features.scss';
import Boost from '../../components/Boost/index';

// IMAGES
import yourUsers from '../../images/illustration-your-users.svg';

export default function Features() {
  return (
    <Fragment>
      <header className='feature-header'>
        <img
          className='feature-header__img'
          src={yourUsers}
          alt='people interacting with screens'
        />
        <div className='feature-header__text'>
          <h1 className='feature-header__h1'>Features your users want</h1>
          <h2 className='feature-header__h2'>
            Build your brand’s recognition and get detailed insights on how your
            links are performing.
          </h2>

          <a href='#features'>
            <button className='btn'>Get Started</button>
          </a>
        </div>
      </header>

      <main className='features'>
        <div className='features__heading-container' id='features'>
          <h3>More Than Links</h3>
          <p className='features__heading-text'>
            We offer a comprehensive suite of services to power your company and
            its products.
          </p>
        </div>
        <div className='features__containers'>
          <div className='features__container first-container'>
            <div className='circle-img'>
              <i className='fas fa-compress-arrows-alt'></i>
            </div>
            <h4>Link Shortening</h4>
            <p>
              Create shorter, more powerful links that your customers will
              trust. All while attracting more clicks.
            </p>
          </div>
          <div className='container__line'></div>
          <div className='wrapper'>
            <div className='features__container second-container'>
              <div className='circle-img'>
                <i className='fas fa-link'></i>
              </div>
              <h4>Branded Links</h4>
              <p>
                Increase engagement and exposure. Simply replace "Short.ly" with
                your brand, and you're set.
              </p>
            </div>
          </div>
          <div className='container__line'></div>
          <div className='features__container third-container'>
            <div className='circle-img'>
              <i className='far fa-chart-bar'></i>
            </div>
            <h4>Analytics</h4>
            <p>
              Track and optimize every initiative with our enterprise-grade
              suite of analytic tools — at a budget-friendly price.
            </p>
          </div>
        </div>
      </main>
      <Boost />
    </Fragment>
  );
}
